import { type Dialog } from '@/core/models/dialog/dialog'
import type { DialogJournalSlide } from './use-prepare-journal-slide'
import type { FinalDialogEvaluationSlideData } from './use-final-evaluation-slide'
import type { FinalDialogPulseSlideData } from './use-final-pulse-slide'
import { FeedbackTopicType } from '@/core/models/feedback-topic'
import type { Comment } from '@/core/composables/use-comments'
import type { ObjectivesByFeedbackTopicViewModel } from '@/core/composables/use-objectives'
import { usePrintData } from '@/core/composables/use-print-data'

export function usePrintDialog() {
  return usePrintData<PrintDialog>({
    loadMockData: async () => {
      const mockData = await import('@/assets/test-data/print-dialog.test-data')
      return mockData.printDialogTestData
    },
  })
}

export interface PrintDialog {
  organizationName: string
  dialog: Dialog
  slides: ReadonlyArray<
    (
      | (DialogJournalSlide & { type: FeedbackTopicType.Journal })
      | (FinalDialogEvaluationSlideData & { type: FeedbackTopicType.Evaluation })
      | (FinalDialogPulseSlideData & { type: FeedbackTopicType.Pulse })
    ) & {
      comments: ReadonlyArray<Comment>
      objectives: ObjectivesByFeedbackTopicViewModel
    }
  >
  memberAvatars: ReadonlyArray<{
    memberId: string
    fileContent: string
  }>
}
